export default __webpack_public_path__ + "static/media/halloffame.b3773d20.jpg";